import apiClient from '../client';
import type { LoginRequest, ConfirmOTPRequest, AuthResponse, AuthTokens, User } from '../types';

export const authAPI = {
  /**
   * Get user account data including subscription
   */
  getAccount: async (userId: string): Promise<User> => {
    const response = await apiClient.get<User>(`/users/${userId}`);
    return response.data;
  },

  /**
   * Request OTP code to be sent to email
   */
  login: async (data: LoginRequest): Promise<void> => {
    await apiClient.post('/auth/login', data);
  },

  /**
   * Register new user with email
   */
  register: async (data: LoginRequest): Promise<void> => {
    await apiClient.post('/auth/register', data);
  },

  /**
   * Confirm OTP code and get JWT tokens
   */
  confirmOTP: async (data: ConfirmOTPRequest): Promise<AuthResponse> => {
    const response = await apiClient.post<AuthResponse>('/auth/confirmation-otp', data);
    return response.data;
  },

  /**
   * Refresh access token using refresh token
   */
  refreshToken: async (refreshToken: string): Promise<AuthTokens> => {
    const response = await apiClient.post<AuthTokens>('/auth/refresh-token', {
      token: refreshToken,
    });
    return response.data;
  },

  /**
   * Logout and clear firebase token on server
   */
  logout: async (): Promise<void> => {
    await apiClient.post('/auth/logout');
  },
};
